import { useState } from "react";
import {useTranslation} from "@i18n";
import { Link } from "react-router-dom";
import {CDN_LINK} from "@globalConfig";
import { onPushDataLayer } from "@/utils/events";
import stl from "./CashPayment.module.css";
import { cashCheckout1Event } from "@/utils/dataLayerEvents";
import { trackEvents } from "@/common/events/events";
import useHelpers from "@hooks/useHelpers";
import useContactNumbers from "@hooks/useContactNumbers";

const CashPayment = ({
  priceSection,
  postId,
  ShowStory,
  arboun,
  hidePaymentBtn,
  reserved,
  g4_data,
}) => {
  const { t } = useTranslation(["web_post_view", "web_common"]);
  const {createUrl} = useHelpers();
  const [showNumbers, setShowNumbers] = useState(false);
  const hasTowPrises = priceSection?.none_vat_price && priceSection?.vat_price;
  const contactNumbers = useContactNumbers();
  return (
    <>
      <div
        className={`${stl.container} ${hasTowPrises ? stl.hasTowPrises : ""}`}>
        <strong className={stl.title}>
          {t("سعر الكاش", { ns: "web_post_view" })}
        </strong>

        <div className={[stl.priceContainer].join(" ")}>
          {priceSection?.none_vat_price && (
            <>
              <div className={stl.priceContSub}>
                <p>{priceSection?.none_vat_price?.header}</p>
                <strong className={[stl.blkColor,"interActiveGreen"].join(" ")}>
                  {priceSection?.none_vat_price?.text}
                  <span className="interActiveGreen">{priceSection?.currency}</span>
                </strong>
              </div>
              <div className={stl.sepMe}></div>
            </>
          )}
          {priceSection?.vat_price && (
            <div className={stl.priceContSub}>
              {hasTowPrises && <p>{priceSection?.vat_price?.header}</p>}
              <strong className="interActiveGreen">
                {priceSection?.vat_price?.text}
                <span className="interActiveGreen">{priceSection?.currency}</span>
              </strong>
              {priceSection?.old_price?.text_with_vat && (
                <strong className={[stl.priceCashON, stl.oldPrice,"interActiveGreen"].join(" ")}>
                  {priceSection?.old_price?.text_with_vat}
                  <span className="interActiveGreen">{priceSection?.currency}</span>
                </strong>
              )}
            </div>
          )}
        </div>

        <div className={stl.note}>


          {!hasTowPrises && (
            <p className="interActiveGray">
              <img
                src={CDN_LINK + "/assets/images/check-mark.svg"}
                width={24}
                height={24}
                alt={"check-mark"}
              />{" "}
              {priceSection?.vat_price?.header}
            </p>
          )}

          <span
            className={stl.startStryNow}
            onClick={() => {
              ShowStory && ShowStory();
            }}>
            {t("كيف تشتري سيارتك من سيارة؟", { ns: "web_post_view" })}
          </span>
        </div>
        {!hidePaymentBtn && (
          <div className={stl.btnsArea}>
            {reserved == 1 ? (
              <div className={stl.reservedCarBox}>
                <strong>
                  {t("هذه السيارة محجوزة", { ns: "web_post_view" })}
                </strong>
                {!showNumbers && (
                  <span
                    className={"greenTextBtn"}
                    onClick={() => {
                      setShowNumbers(true);
                    }}>
                    {t("تواصل مع مندوب المبيعات", { ns: "web_post_view" })}
                  </span>
                )}
              </div>
            ) : (
              <>
                <Link
                  className={["greenBtn"].join(" ")}
                  to={createUrl(
                    `/checkout/shop-apply?postId=${postId}`
                  )}
                  onClick={() => {
                    cashCheckout1Event("checkout_lead", g4_data);
                    trackEvents("book_car", {
                      ...g4_data,
                      post_trim: g4_data?.post_ext,
                    });
                  }}>
                  {t("احجزها الآن", {
                    ns: "web_post_view",
                  })}{" "}
                  {`${arboun} ${t("ريال", {
                    ns: "web_post_view",
                  })}`}
                </Link>
                {!showNumbers && (
                  <span
                    onClick={() => {
                      setShowNumbers(true);
                    }}
                    className={["greenTextBtn", stl.reserveNowBtn].join(" ")}>
                    {t("اتصل بنا للحجز", { ns: "web_post_view" })}
                  </span>
                )}
              </>
            )}

            {showNumbers && (
              <div className={stl.callUsBy}>
                <span
                  onClick={() => {
                    setShowNumbers(false);
                  }}>
                  <img src="/assets/bundles/close_search.svg" alt="" />
                </span>
                <strong>
                  {t("تواصل معنا عن طريق", { ns: "web_post_view" })}
                </strong>
                <a
                  href={`tel:${contactNumbers.callCenterCallNumber}`}
                  className={stl.SOLcallus}
                  onClick={() => {
                    //  onlineContactEvent("call", "Car Details", postId);
                    trackEvents("online_contact", {
                      post_id: postId,
                      contact_type: "call",
                      contact_location: "Car Details",
                    });
                    onPushDataLayer(
                      "postdetails.lead",
                      "Post Details",
                      "Lead",
                      "Call"
                    );
                  }}>
                  <div>
                    <img src={CDN_LINK+"/assets/bundles/Call.svg"} alt="" />
                    <span>{t("اتصال", { ns: "web_post_view" })}</span>
                  </div>
                  <div style={{ direction: "ltr" }}>
                    {contactNumbers.callCenterDisplayNumber}
                  </div>
                </a>
                <a
                  href={`https://api.whatsapp.com/send?phone=${contactNumbers.whatsappCallNumber}&amp;`}
                  rel="noopener noreferrer" target="_blank"
                  className={stl.SOLwhatus}
                  onClick={() => {
                    //onlineContactEvent("whatsapp", "Car Details", postId);
                    trackEvents("online_contact", {
                      post_id: postId,
                      contact_type: "whatsapp",
                      contact_location: "Car Details",
                    });
                    onPushDataLayer(
                      "postdetails.lead",
                      "Post Details",
                      "Lead",
                      "WhatsApp"
                    );
                  }}>
                  <div>
                    <img
                      src="/assets/bundles/wpImg.svg"
                      alt=""
                      width={24}
                      height={24}
                    />
                    <span>{t("واتساب", { ns: "web_post_view" })}</span>
                  </div>
                  <div style={{ direction: "ltr" }}>
                    {contactNumbers.whatsappDisplayNumber}
                  </div>
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default CashPayment;
